import React from "react";
import { colors } from "../../../utils/colors";

export default function PickupTab({ tabId, setTabId }) {
  return (
    <div
      className="col-lg-4 col-12 my-auto dc-l-mb-c d-flex align-items-center"
      style={{
        gap: 20,
      }}
    >
      {[
        {
          label: "Prekių atsiėmimas punkte",
          value: "pickups",
        },
        {
          label: "Likučiai",
          value: "leftovers",
        },
      ].map(({ label, value }) => (
        <div
        key={value}
          className="text-lg font-medium cursor-pointer cursor-pointer"
          style={{
            color: tabId == value ? "#212529" : "#2125295E",
            borderBottom: `2px solid ${
              tabId == value ? colors["technorama"] : "transparent"
            }`,
          }}
          onClick={() => setTabId(value)}
        >
          {label}
        </div>
      ))}
    </div>
  );
}
